import * as axiosService from "./axiosRequests";
import { IWebhookAttributes, IWebhook } from "../types/IWebhook";
import { endpoint } from "../utils/endpoint";

export const WEBHOOK_ENDPOINT_ENDPOINT = (webhookEndpointId: string): string => endpoint(`app/v1.0/webhook_endpoints/${webhookEndpointId}`);

export const putWebhookEndpoint = async (
  webhookEndpointId: string,
  payload: Partial<IWebhookAttributes>,
): Promise<IWebhook> => {
  const response = await axiosService.axiosPut(
    WEBHOOK_ENDPOINT_ENDPOINT(webhookEndpointId),
    {
      webhook_endpoint: payload,
    },
  );

  return response.data;
};

export default { putWebhookEndpoint };
